import { z } from 'zod';
import { Temporal } from 'temporal-polyfill';
import { formatPlainDate } from '../temporal-utils/formatting.js';

export const scheduleBreakLikeSchema = z.object({
  startPlainDate: z.instanceof(Temporal.PlainDate),
  endPlainDate: z.instanceof(Temporal.PlainDate),
  name: z.string().nullable(),
});
export type ScheduleBreakLike = z.infer<typeof scheduleBreakLikeSchema>;

export const scheduleBreakSchema = z
  .object({
    id: z.string(),
    scheduleId: z.string(),
  })
  .extend(scheduleBreakLikeSchema.shape);
export type ScheduleBreak = z.infer<typeof scheduleBreakSchema>;

export function formatScheduleBreak(breakItem: {
  startPlainDate?: Temporal.PlainDate;
  endPlainDate?: Temporal.PlainDate;
}): string {
  const start = breakItem.startPlainDate ? formatPlainDate(breakItem.startPlainDate) : '';
  const end = breakItem.endPlainDate ? formatPlainDate(breakItem.endPlainDate) : '';
  return start && end ? `${start}, ${end}` : '';
}

export function formatScheduleBreaks(
  breaks: Array<{ startPlainDate?: Temporal.PlainDate; endPlainDate?: Temporal.PlainDate }>,
): string {
  return breaks.map(formatScheduleBreak).filter(Boolean).join('; ');
}
